import moment from 'moment';
import React from 'react';
import { Alert, Carousel, Col, Row } from 'react-bootstrap';
import { Link } from "react-router-dom";
import './Home.css';


export default class Registration extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            startDate: moment(),
            packages: [],
            avaliableDates: [],
            westonDates: [],
            westRoxburyDates: [],
            locationDates: []
        };
        this.handleChange = this.handleChange.bind(this);
    }
    handleChange(date) {
        this.setState({
            startDate: date
        });
    }
    componentDidMount() {
        const that = this;
        fetch('https://s3.amazonaws.com/publicdates/roadTestPackages.json', {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            method: 'GET'
        })
            .then(this.handleErrors)
            .then(function (response) {
                return response.json();
            }).then(function (data) {
                console.log(data);
                that.setState({ packages: data });

            });

        fetch('https://s3.amazonaws.com/publicdates/roadTestDates.json', {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            method: 'GET'
        })
            .then(this.handleErrors)
            .then(function (response) {
                return response.json();
            }).then(function (data) {
                data = JSON.parse(data);
                console.log(data);
                if (data !== null) {
                    var avaliableDates = Object.keys(data).filter(x => moment(x).isAfter(moment()))
                        .map(x => moment(x))
                        .sort(function (a, b) { return a - b; });
                    console.log(data, avaliableDates);

                    var avaliableDatesKeys = avaliableDates.map(x => x.toISOString());

                    var locationDates = [];

                    avaliableDatesKeys.forEach(function (date) {
                        console.log(date);
                        var locations = data[date].locations.map(f => f.toUpperCase());
                        var dateText = "";
                        var location = "";
                        if (moment(date).day() === 6) {
                            dateText = "Saturday " + moment(date).format('M/D');
                        } else {
                            dateText = " Weekday " + moment(date).format('M/D') + " " + moment(date).format('ddd');
                        }
                        dateText += " - ";
                        if (locations.length > 2) {
                            location += locations.slice(0, locations.length - 1).join(", ");
                            location += " AND ";
                            location += locations.slice(locations.length - 1, locations.length);
                        } else {
                            location += locations.join(" AND ");
                        }
                        locationDates.push({
                            datetext: dateText,
                            location: location
                        });

                    });

                    that.setState({ avaliableDates: avaliableDates, roadTestDates: data, locationDates });

                }
            });
    }
    // React components are simple functions that take in props and state, and render HTML
    render() {
        return (

            <div className="holder">
                <h2>Boston Road Tests</h2>
                <h4 className="subBorder">Take Your Road Test in Boston at Parkway Driving School</h4>
                <Carousel>
                    <Carousel.Item>
                        <img
                            className="img-fluid d-block mx-auto"
                            alt="900x500"
                            src={process.env.PUBLIC_URL + '/photo1.jpg'}
                        />
                        <Carousel.Caption>
                            <span className="carouselTitle">Schedule your road test today</span>
                            <p className="carouselSubtitle">We will take care of everything for you</p>
                        </Carousel.Caption>
                    </Carousel.Item>
                    <Carousel.Item>
                        <img
                            className="img-fluid d-block mx-auto"

                            alt="900x500"
                            src={process.env.PUBLIC_URL + '/photo2.jpg'}
                        />
                        <Carousel.Caption>
                            <span className="carouselTitle">Get Prepped for your Road Test</span>
                            <p className="carouselSubtitle">With our Road Test with One Lesson Package</p>
                        </Carousel.Caption>
                    </Carousel.Item>
                    <Carousel.Item>
                        <img
                            className="img-fluid d-block mx-auto"

                            alt="900x500"
                            src={process.env.PUBLIC_URL + '/photo3.jpg'}
                        />
                        <Carousel.Caption>
                            <span className="carouselTitle">Fast, easy service!</span>
                            <p className="carouselSubtitle">Why wait months for the RMV, we will schedule in just a few weeks!</p>
                        </Carousel.Caption>
                    </Carousel.Item>
                </Carousel>
                <h5 className="carouselUnder">We offer road tests in the Boston, MA area!</h5>
                <div>
                    <div className="homeDescription">
                        Getting your road test requirement can be a stressful event, but it doesn't have to be.
                        With our convenient road test dates and online scheduler, you can easily be on the road.
                        <br></br>
                        <ul className="warn">
                            <li>All prices do not include RMV fees, those are separate and paid directly to the RMV. ($50 - one time license fee &amp; $35 road test exam fee)</li>
                            <li>There are no refunds or cancellations for a road test for any reason including illness, emergency, being removed from our list by the RMV or rejection by the RMV examiner.</li>
                            <li>The RMV has changed the days that the road tests can be. Either Saturday or Mondays. We have only ever had a Saturday test, but the examiner only comes to our school once per week.</li>
                            <li>Tests take place between 9am – 2:30pm.</li>
                            <li>There are no rescheduling or refunds if you are unavailable the day the road test examiner is coming to Parkway.</li>
                            <li>All tests are conducted by an examiner from the Registry of Motor Vehicles.</li>
                            <li>Parkway will be your sponsor, you will use our car, and we will schedule your test with the RMV.</li>
                            <li>You do not have to be a Parkway student to take the test at our school. You do not have to take any lessons, but we highly recommend one lesson.</li>
                            <li>All West Roxbury and Braintree road test prep lessons are in West Roxbury, and all Walpole road test prep lessons are in Walpole. The address will be in your confirmation email.</li>
                        </ul>
                    </div>
                    <br></br>
                    <br></br>

                    <div className='center'>
                        <Alert variant="warning">
                            <Alert.Heading>Current Road Test Availability Dates</Alert.Heading>
                            <p>
                                These dates are subject to changes at the discretion of the RMV. We cannot guarantee any dates at this time.
                            </p>
                            <p>
                            </p>
                            <Row>
                                <Col>
                                    {this.state.locationDates.length > 0 ?
                                        <div>
                                            {this.state.locationDates.map((datedata, key) => {
                                                return <div key={key}>{datedata.datetext}  <span className="warn">{datedata.location}</span></div>;
                                            })}
                                        </div>
                                        : "No Road Tests Currently Avaliable"}
                                </Col>
                            </Row>
                        </Alert>

                    </div>
                    <br></br>
                    {this.state.packages.length > 0 ? <Row>
                        <Col>
                            <div className="card card-body bg-light">
                                Package: Road Test Only $({this.state.packages.filter(x => x.package === "Road Test Only")[0].price.replace(" ", "")})
                                <p>We'll take care of everything for you, except the Road Test by:</p>
                                <ul>
                                    <li>Scheduling an appointment on a date convenient for you.</li>
                                    <li>Having our trained sponsor meet you on-site. </li>
                                    <li>Providing an easily manueaverable Road Test ready Kia Soul</li>
                                    <li>Note: Test will either be on a Saturday or a Monday. You will find out your timeslot a week before your test.</li>
                                    <li>Tests take place between 9 am - 2:30 pm.</li>
                                </ul>
                            </div>
                        </Col>

                        <Col>
                            <div className="card card-body bg-light">
                                Package: Road Test w/ One Lesson $({this.state.packages.filter(x => x.package === "Road Test w/ One Lesson")[0].price.replace(" ", "")})

                                <p>You will have all the benefits of the Road Test Only package as well as increasing your chances of passing with a 45-minute private lesson with Parkway Driving School</p>
                                <p>This lesson will cover:</p>
                                <ul>
                                    <li>Taking a simulated road test.</li>
                                    <li>Going over common road test scenarios.</li>
                                    <li>Using the vehicle you'll be using for the Road Test.</li>
                                    <li>Prep lessons can not be the same day as your test.</li>
                                    <li>Tests take place between 9 am - 2:30 pm.</li>
                                </ul>
                            </div>
                        </Col>
                        <Col>
                            <div className="card card-body bg-light">
                                Package: Weekday Road Test @ RMV LOCATION $(150 CREDIT CARD)

                                <p>We'll take care of everything for you, except the Road Test by:</p>
                                <ul>
                                    <li>Scheduling an appointment at an RMV location.</li>
                                    <li>Having our trained sponsor meet you on-site. </li>
                                    <li>Providing an easily manueaverable Road Test ready Kia Soul; you do not use your car.</li>
                                    <li>Note: All RMV road test will take place between 9- 10 am, and may be earlier than your scheduled time.  </li>
                                    <li>Prep lessons can not be the same day as your test.</li>
                                </ul>
                            </div>
                        </Col>

                    </Row> : null}

                    <br></br>
                    <div className='center'>
                        5% Discount for all cash payments. Must visit office to pay by cash. Please call the office for details.
                        <Link to="/registration" className="btn btn-primary full">
                            Register for Road Test
                        </Link>
                    </div>
                    <br></br>

                    <div className="footer">
                        <Row>
                            <Col className='center'>
                                <div><strong>Phone: </strong> (617) 477-4257</div>
                                <div><strong>Text Line Only: </strong> (617) 564-3803</div>
                                <div><strong>Email: </strong><a href="mailto:info@parkwaydrivingschool.com">info@parkwaydrivingschool.com</a></div>
                                <div><strong>Address: </strong>1752 Centre St, West Roxbury, MA 02132</div>

                                <br></br>
                            </Col>
                        </Row>
                        <br></br>
                    </div>

                    <br></br>
                </div>

            </div >
        );
    }
}
